/* cookie-banner.js — the theme's cookie banner (snippet cookie-banner: its
   markup; its rules: cookie-banner.css), on Shopify's Customer Privacy API
   (shopify.dev/docs/api/customer-privacy).
   - Up only where Shopify asks for consent (shouldShowBanner(): the regions of
     the shop's privacy settings, the EEA, the UK, Switzerland) and while the
     visitor has said nothing (currentVisitorConsent()).
   - accept / decline / save: setTrackingConsent({ analytics, marketing,
     preferences, sale_of_data }), only ever on the visitor's own press.
   - A dialog, not modal: up by itself it takes no focus (it is the keyboard's
     first stop after the skip link); opened from a link it takes it (the card:
     announced as the dialog) and gives it back when it goes. Escape: from the
     detail back to the sentence; else it goes without a choice recorded, back
     at the next visit (sessionStorage, try/catch). "your choice is saved." is
     said after a choice (role="status").
   - The way back: "your privacy choices" (/pages/data-sharing-opt-out: Shopify's
     own page where it handles the sale of data, saleOfDataRegion()), the foot's
     small "cookies" ([data-ck-reopen], shown where the banner has a say), any
     [data-ck-open].
   - Standalone: no drayki.js needed (the bare layout of /pages/halo). */
(function () {
  var el = document.getElementById('ck');
  if (!el || el._ck) return;
  el._ck = true;
  var W = window, D = document, root = D.documentElement;
  var said = D.querySelector('[data-ck-said]');
  var editor = el.hasAttribute('data-ck-editor');
  var LATER = 'drayki-cookies-later';
  var views = { ask: el.querySelector('[data-ck-view="ask"]'), choose: el.querySelector('[data-ck-view="choose"]') };
  var keys = Array.prototype.slice.call(el.querySelectorAll('[data-ck-k]'));
  var toChoose = el.querySelector('[data-ck-go="choose"]');
  var design = el.hasAttribute('data-ck-design');
  var css = document.querySelector('link[data-ck-css]');
  var cp = null, cur = 'ask', opener = null, ro = null;
  var later = {
    get: function () { try { return W.sessionStorage.getItem(LATER) === '1'; } catch (e) { return false; } },
    set: function () { try { W.sessionStorage.setItem(LATER, '1'); } catch (e) {} }
  };
  // what the visitor said: 'yes' / 'no' a purpose, '' before any choice
  function now() { try { return (cp && cp.currentVisitorConsent && cp.currentVisitorConsent()) || {}; } catch (e) { return {}; } }
  function decided() { var c = now(); return ['analytics', 'marketing', 'preferences'].some(function (k) { return c[k] === 'yes' || c[k] === 'no'; }); }
  // the room it takes at the foot (the page's end leaves it that much)
  function size() { if (el.classList.contains('on')) root.style.setProperty('--ck-h', (el.offsetHeight + 16) + 'px'); }
  function view(v) {
    cur = v;
    views.ask.hidden = v !== 'ask';
    views.choose.hidden = v !== 'choose';
    el.setAttribute('aria-describedby', v === 'ask' ? 'ck-d' : 'ck-i');
    size();
  }
  function fill() { var c = now(); keys.forEach(function (b) { b.setAttribute('aria-checked', c[b.getAttribute('data-ck-k')] === 'yes' ? 'true' : 'false'); }); }
  // (the card is shown once its rules are in: they load without holding the page)
  function styled(then) {
    if (!css || css.sheet) { then(); return; }
    css.addEventListener('load', then, { once: true });
  }
  function show(v, from) { styled(function () { up(v, from); }); }
  function up(v, from) {
    opener = from || null;
    fill();
    view(v);
    el.hidden = false;
    void el.offsetWidth;   // (its first frame is the closed one: it comes up)
    el.classList.add('on');
    root.classList.add('ck-up');
    size();
    if (!ro && 'ResizeObserver' in W) { ro = new ResizeObserver(size); ro.observe(el); }
    if (from) el.focus({ preventScroll: true });   // (announced as the dialog; Tab reaches its first key)
  }
  // where the focus goes when it leaves with it: back to what opened it,
  // else on to the next thing the keyboard would have reached
  function after() {
    var list = D.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex="0"]');
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (el.contains(n) || !(el.compareDocumentPosition(n) & 4)) continue;
      if (n.getClientRects().length && W.getComputedStyle(n).visibility !== 'hidden') return n;
    }
    return D.getElementById('main');
  }
  function hide() {
    var had = el.contains(D.activeElement);
    el.classList.remove('on');
    root.classList.remove('ck-up');
    if (had) {
      var back = opener && opener.isConnected ? opener : after();
      if (back && back.focus) back.focus({ preventScroll: true });
    }
    opener = null;
  }
  // the foot's small way back ([data-ck-reopen]) shows where the banner has a say
  function here(on) { Array.prototype.forEach.call(D.querySelectorAll('[data-ck-reopen]'), function (r) { r.hidden = !on; }); }
  function record(o) {
    var done = function () {
      here(true);
      if (!said) return;
      said.textContent = '';
      setTimeout(function () { said.textContent = said.getAttribute('data-saved') || ''; }, 80);   // (said again, even when it is the same word)
    };
    hide();
    if (editor || !cp || !cp.setTrackingConsent) { done(); return; }
    try { cp.setTrackingConsent(o, done); } catch (e) {}
  }
  function all(on) { return { analytics: on, marketing: on, preferences: on, sale_of_data: on }; }
  el.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ck-go], [data-ck-k], .ck-r');
    if (!t) return;
    if (t.hasAttribute('data-ck-k') || t.classList.contains('ck-r')) {
      var b = t.hasAttribute('data-ck-k') ? t : t.querySelector('[data-ck-k]');
      if (b) b.setAttribute('aria-checked', b.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      return;
    }
    var go = t.getAttribute('data-ck-go');
    if (go === 'accept') record(all(true));
    else if (go === 'decline') record(all(false));
    else if (go === 'choose') { view('choose'); if (keys[0]) keys[0].focus(); }
    else if (go === 'back') { if (opener) hide(); else { view('ask'); if (toChoose) toChoose.focus(); } }
    else if (go === 'save') { var o = {}; keys.forEach(function (b) { o[b.getAttribute('data-ck-k')] = b.getAttribute('aria-checked') === 'true'; }); record(o); }
  });
  el.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !el.classList.contains('on')) return;
    e.stopPropagation();
    if (cur === 'choose' && !opener) { view('ask'); if (toChoose) toChoose.focus(); return; }
    if (!opener) later.set();   // no choice made: nothing recorded, back at the next visit
    hide();
  });
  // the way back: "your privacy choices" (except where Shopify's own page
  // handles the sale of data), the foot's "cookies", any [data-ck-open]
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ck-open], a[href*="/pages/data-sharing-opt-out"]');
    if (!t || el.contains(t)) return;
    if (!editor && !cp) return;   // (no API: Shopify's own page, as before)
    if (!t.hasAttribute('data-ck-open') && cp) { try { if (cp.saleOfDataRegion && cp.saleOfDataRegion()) return; } catch (x) { return; } }
    e.preventDefault();
    show('choose', t);
  });
  D.addEventListener('visitorConsentCollected', function () { if (el.classList.contains('on') && !opener) hide(); here(true); });
  // what Shopify says: a region where the shop asks for consent, and nothing
  // said yet (shouldShowBanner() stays true after a choice in some versions:
  // the card never comes back over a choice made)
  function decide(api) {
    if (!api) return;
    cp = api;
    var should = false;
    try { should = !!(cp.shouldShowBanner && cp.shouldShowBanner()); } catch (x) {}
    var known = decided();
    here(should || known);
    if (should && !known && !later.get()) show('ask');
  }
  // the API was asked for by the snippet as the page began (DRAYKI_CK: it loads
  // while the page does); asked again here if Shopify's loader was not there yet.
  // In the editor: only the preview the settings ask for, never the API.
  if (editor) show('ask');
  else if (!design) {
    var ask = function () {
      var S = W.Shopify;
      if (S && typeof S.loadFeatures === 'function') S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) decide(S.customerPrivacy); });
    };
    if (W.DRAYKI_CK && typeof W.DRAYKI_CK.then === 'function') W.DRAYKI_CK.then(function (api) { if (api) decide(api); else ask(); }); else ask();
  }
})();
